import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../data/contact';

function AboutPage() {
  return (
    <div className="container">
      <h2>About GetSkimp</h2>
      <p style={{ marginTop: '1.5rem' }}>
        GetSkimp is an insurance brokerage founded on the promise of delivering the best quality and
        priced insurance tailored to the needs of our clients. We add a layer of personalized service
        and care throughout the entire insurance lifecycle. From quoting and binding to ongoing policy
        support and renewals, we offer our support to ensure the best coverage at the most competitive
        price.
      </p>
      <p style={{ marginTop: '1rem', fontWeight: 600 }}>
        Put short: We make insurance easy for Texans.
      </p>

      <h3 style={{ marginTop: '2.5rem', color: 'var(--color-green)' }}>Why GetSkimp?</h3>
      <p style={{ marginTop: '1rem', lineHeight: 1.7 }}>
        Insurance shouldn't feel like a black hole of misinformation and confusion. Too many people
        pay for coverage they don't understand, from providers who disappear the moment a policy is
        signed. GetSkimp was built to change that. We find you the best insurance options at the most
        competitive price, and we stay with you long after the policy is in place. Whether it's a
        question about your coverage, a claim, or something that has nothing to do with your policy at
        all, we're here to help. We believe insurance should come with the same level of care and
        attention you'd expect from a hospitality experience, and that's exactly what we deliver.
      </p>

      <h3 style={{ marginTop: '2.5rem', color: 'var(--color-green)' }}>Talk to us</h3>
      <p style={{ marginTop: '1rem', lineHeight: 1.7 }}>
        Call{' '}
        <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_DISPLAY}</a> (8:00 AM–8:00 PM Central Time) or visit
        our{' '}
        <a href="/help">Support Center</a>.
      </p>
    </div>
  );
}

export default AboutPage;


